import Button from "@/components/Button";
import InputField from "@/components/InputField";
import { useEffect, useState } from "react";
import { Oval } from "react-loading-icons";
import { useDispatch } from "react-redux";

import { APIStatus } from "../../../../api/APIStatus.type";
import { shareSquad } from "../../../../api/privateRequests/squad-builder/share-squad";
import { copy } from "../../../../icons";
import { addAlert } from "../../../../redux/message/messageSlice";
import { AppDispatch } from "../../../../redux/store";

type ShareSquadSectionProps = {
  squadData?: any;
};

const ShareSquadSection = ({ squadData }: ShareSquadSectionProps) => {
  const dispatch = useDispatch<AppDispatch>();
  const [statusShareSquad, setStatusShareSquad] = useState<APIStatus>("idle");
  const [shareSquadUrl, setShareSquadUrl] = useState<string>("");

  useEffect(() => {
    if (!squadData) return;

    const generateShareSquadUrl = async () => {
      try {
        const res = await shareSquad(squadData);
        setShareSquadUrl(window.location.href + "?id=" + res.id);
        setStatusShareSquad("fulfilled");
      } catch {
        setStatusShareSquad("rejected");
      }
    };
    setStatusShareSquad("pending");
    generateShareSquadUrl();
  }, [squadData]);

  const handleCopy = () => {
    if (shareSquadUrl) {
      navigator.clipboard.writeText(shareSquadUrl).then(
        () => {
          dispatch(
            addAlert({
              title: "Success",
              description: "Copied to clipboard",
              type: "success",
            }),
          );
        },
        (err) => {
          console.error("Failed to copy: ", err);
        },
      );
    }
  };

  return (
    <div className="flex flex-col mb-2 mt-4 text-center items-center">
      {statusShareSquad === "rejected" ? (
        <p className="text-dark-secondary text-sm">
          Sorry, we are unable to process your request at the moment.
        </p>
      ) : (
        <div className="flex flex-row gap-x-2">
          <InputField
            value={shareSquadUrl}
            placeholder={"generating link..."}
            onChange={() => {}}
            dismissSearch={() => {}}
            type={"default"}
            readOnly={true}
          />
          <div>
            <Button
              onClick={handleCopy}
              variant={"primary"}
              label="Copy"
              large
              icon={copy}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default ShareSquadSection;
